<template>
    <div>
      <!-- <div class="topLine"></div> -->
      <ul class="mbtiDescribeBox">
        <li class="greenBox">
          <div class="topContent">
            <div class="iconBox">
              <img src="../../assets/mbtiDescribe/enfp.png" alt="">
            </div>
            <div class="topRight">
              <header>ENFP</header>
              <p>{{ $t('mbti_intro_enfp_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_enfp_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_enfp_love') }}</p>
          </div>
        </li>
        <li class="purpleBox">
          <div class="topContent">
            <div class="iconBox" style="width: 1.76rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/intj.png" alt="">
            </div>
            <div class="topRight">
              <header>INTJ</header>
              <p>{{ $t('mbti_intro_intj_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_intj_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_intj_love') }}</p>
          </div>
        </li>
        <li class="blueBox">
          <div class="topContent">
            <div class="iconBox" style="width: 2.9rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/esfj.png" alt="">
            </div>
            <div class="topRight" style="width: 2rem;">
              <header>ESFJ</header>
              <p>{{ $t('mbti_intro_esfj_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_esfj_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_esfj_love') }}</p>
          </div>
        </li>
        <li class="yellowBox">
          <div class="topContent">
            <div class="iconBox" style="width: 2.09rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/estp.png" alt="">
            </div>
            <div class="topRight">
              <header>ESTP</header>
              <p>{{ $t('mbti_intro_estp_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_estp_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_estp_love') }}</p>
          </div>
        </li>
        <li class="greenBox">
          <div class="topContent">
            <div class="iconBox" style="width: 1.8rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/enfj.png" alt="">
            </div>
            <div class="topRight">
              <header>ENFJ</header>
              <p>{{ $t('mbti_intro_enfj_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_enfj_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_enfj_love') }}</p>
          </div>
        </li>
        <li class="purpleBox">
          <div class="topContent">
            <div class="iconBox" style="width: 2.77rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/entj.png" alt="">
            </div>
            <div class="topRight" style="width:2.1rem">
              <header>ENTJ</header>
              <p>{{ $t('mbti_intro_entj_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_entj_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_entj_love') }}</p>
          </div>
        </li>
        <li class="blueBox">
          <div class="topContent">
            <div class="iconBox" style="width: 1.45rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/isfj.png" alt="">
            </div>
            <div class="topRight">
              <header>ISFJ</header>
              <p>{{ $t('mbti_intro_isfj_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_isfj_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_isfj_love') }}</p>
          </div>
        </li>
        <li class="yellowBox">
          <div class="topContent">
            <div class="iconBox" style="width: 2.35rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/istp.png" alt="">
            </div>
            <div class="topRight">
              <header>ISTP</header>
              <p>{{ $t('mbti_intro_istp_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_istp_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_istp_love') }}</p>
          </div>
        </li>
        <li class="greenBox">
          <div class="topContent">
            <div class="iconBox" style="width: 2.6rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/infp.png" alt="">
            </div>
            <div class="topRight">
              <header>INFP</header>
              <p>{{ $t('mbti_intro_infp_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_infp_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_infp_love') }}</p>
          </div>
        </li>
        <li class="purpleBox">
          <div class="topContent">
            <div class="iconBox" style="width: 2.32rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/entp.png" alt="">
            </div>
            <div class="topRight">
              <header>ENTP</header>
              <p>{{ $t('mbti_intro_entp_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_entp_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_entp_love') }}</p>
          </div>
        </li>
        <li class="blueBox">
          <div class="topContent">
            <div class="iconBox" style="width: 1.89rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/estj.png" alt="">
            </div>
            <div class="topRight">
              <header>ESTJ</header>
              <p>{{ $t('mbti_intro_estj_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_estj_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_estj_love') }}</p>
          </div>
        </li>
        <li class="yellowBox">
          <div class="topContent">
            <div class="iconBox" style="width: 2.01rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/esfp.png" alt="">
            </div>
            <div class="topRight">
              <header>ESFP</header>
              <p>{{ $t('mbti_intro_esfp_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_esfp_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_esfp_love') }}</p>
          </div>
        </li>
        <li class="greenBox">
          <div class="topContent">
            <div class="iconBox" style="width: 2.43rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/infj.png" alt="">
            </div>
            <div class="topRight">
              <header>INFJ</header>
              <p>{{ $t('mbti_intro_infj_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_infj_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_infj_love') }}</p>
          </div>
        </li>
        <li class="purpleBox">
          <div class="topContent">
            <div class="iconBox" style="width: 2.02rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/intp.png" alt="">
            </div>
            <div class="topRight">
              <header>INTP</header>
              <p>{{ $t('mbti_intro_intp_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_intp_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_intp_love') }}</p>
          </div>
        </li>
        <li class="blueBox">
          <div class="topContent">
            <div class="iconBox" style="width: 1.79rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/istj.png" alt="">
            </div>
            <div class="topRight">
              <header>ISTJ</header>
              <p>{{ $t('mbti_intro_istj_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_istj_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_istj_love') }}</p>
          </div>
        </li>
        <li class="yellowBox">
          <div class="topContent">
            <div class="iconBox" style="width: 2.32rem;height: 1.92rem;">
              <img src="../../assets/mbtiDescribe/isfp.png" alt="">
            </div>
            <div class="topRight">
              <header>ISFP</header>
              <p>{{ $t('mbti_intro_isfp_pers') }}</p>
            </div>
          </div>
          <div class="bottomContent">
            <header>{{ $t('mbti_intro_pers') }}</header>
            <p>{{ $t('mbti_intro_isfp_feature') }}</p>
            <header>{{ $t('mbti_intro_love') }}</header>
            <p>{{ $t('mbti_intro_isfp_love') }}</p>
          </div>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: "mbtiDescribe",
    data() {
      return {
        langType: "",
      };
    },
    created() {
        this.langType = this.$route.query.langType;
        this.language()
    },
    mounted() {
    },
    methods: { 
        language() {
            let langs = this.langType.substring(0, 2);
            let lang = this.langType;
            if (langs == "zh") {
                if (lang == "zh_TW" || lang == "zh_HK") {
                this.$i18n.locale = "tc";
                } else {
                this.$i18n.locale = "zh";
                }
            } else if (langs == "en") {
                this.$i18n.locale = "en";
            } else if (langs == "ar") {
                this.$i18n.locale = "ar";
            }else if (langs == "tr") {
                this.$i18n.locale = "tr";
            } else if (langs == "es") {
                this.$i18n.locale = "es";
            } else if (langs == "pt") {
                this.$i18n.locale = "pt";
            } else {
                this.$i18n.locale = "en";
            }
            document.title = this.$t('mbti_intro_title')
            document.querySelector("html").setAttribute("lang", this.$i18n.locale);
        },
    },
  };
  </script>
  
  <style scoped>
  html[lang="ar"] .mbtiDescribeBox{
    direction: rtl;
}
html[lang="ar"] img{
  transform: scaleX(-1);
}
  .mbtiDescribeBox{
    width: 592px;
    margin: 0 auto;
    font-family: 'Montserrat';
    padding-bottom: 30px;
  }
  .mbtiDescribeBox li{
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    margin-bottom: 32px;
    padding: 32px;
    border-radius: 24px;
  }
  .greenBox{
    background: #ECF1E7;
  }
  .topContent{
    margin-bottom: 40px;
  }
  .topContent>div{
    display: inline-block;
  }
  .iconBox{
    width: 196px;
    height: 176px;
  }
  img{
    display: block;
    width: 100%;
    height: 100%;
  }
  .topRight header{
    font-size: 48px;
    line-height: 76px;
    color: #141414;
    font-weight: 700;
  }
  .topRight{
    vertical-align: top;
    padding-top: 13px;
    margin-left: 32px;
    width: 230px;
  }
  .topRight p{
    font-size: 34px;
    line-height: 44px;
    font-weight: 400;
    color: #9D9D9D;
  }
  .bottomContent header{
    font-size: 34px;
    line-height: 54px;
    font-weight: 700;
    margin-bottom: 16px;
    color: #9D9D9D;
  }
  .bottomContent header:nth-of-type(2){
    margin-top: 24px;
  }
  .bottomContent p{
    font-size: 30px;
    line-height: 40px;
    font-weight: 400;
    color: #000000;
    padding: 24px;
    border: 2px dashed #B2B2B2;
    border-radius: 24px;
    width: 100%;
    box-sizing: border-box;
  }
  .topLine{
    width: 100%;
    height: 9px;
    background: url('../../assets/mbtiDescribe/topLine.png') no-repeat;
    background-size: 100% 100%;
  }
  .purpleBox{
    background: #EDE7F1;
  }
  .blueBox{
    background: #E6F0EF;
  }
  .yellowBox{
    background: #F0EEE6;
  }
  </style>
  